import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SuccessfulSearchesService {
    public constructor(private http: HttpClient) {}

    public getLatestSuccessfulSearchTerms(maxResults: number): Observable<string[]> {
        return this.http.get<string[]>('/api/latestSearch', {
            params: { maxResults },
        });
    }
}
